import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default function ProductsController(props) {
    const ProductsView = ComponentRegistry.get(props.view);

    return (
      <ProductsView
        {...props} view={props.productView}
      />
    );
}

ProductsController.propTypes = {
    view: PropTypes.string.isRequired,
};

ProductsController.defaultProps = {
    view: "ProductListViewsProductsView",
    productView: "ProductBrowserViewsThumbView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductList/Controllers/ProductsController.jsx